import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  sendOtp(payload: any): Observable<any> {
    return this.post<any>('sms/otp', payload, {
      headers: this.getHeaders()
    });
  }

  otpVerification(payload: any): Observable<any> {
    return this.post<any>('sms/otp/varify', payload, {
      headers: this.getHeaders()
    });
  }

  setupNewPassword(payload: any): Observable<any> {
    return this.post<any>('sp/register', payload, {
      headers: this.getHeaders()
    });
  }

  login(payload: any): Observable<any> {
    return this.post<any>('login', payload, {
      headers: this.getHeaders()
    });
  }

  forgotPassword(payload: any) {
    return this.post<any>('sp/send-otp-forgot-password', payload, {
      headers: this.getHeaders()
    });
  }

  emailVerification(payload: any) {
    return this.post<any>('sms/otp/varify', payload, {
      headers: this.getHeaders()
    });
  }

  chnagePassword(payload: any) {
    return this.patch<any>('sp/forgot-password', payload, {
      headers: this.getHeaders()
    });
  }

  resendVerificationLink(email: any) {
    return this.post<any>('sp/resend-verification-link', email, {
      headers: this.getHeaders()
    });
  }

  signout(imei: any) {
    let params = new HttpParams()
      .set('imei', imei)
    return this.delete<any>('user/logout', {
      headers: this.getHeaders(),
      params: params
    });
  }
}
